module.exports = __webpack_public_path__ + "static/media/downArrowCookie.f833ff8f.svg";